export enum TableType {
    MyTable = "MY_TABLE",
    CollaboratorTable = "COLLABORATOR_TABLE",
}

export enum SideColumnsType {
    CallerColumns = "caller_columns",
    CollaboratorColumns = "collaborator_columns",
}
